import * as React from 'react';
import { BoardComponent } from './components/BoardComponent';
import { LoadingComponent } from './components/LoadingComponent';

interface IAppState {
  loaded: boolean;
  isMobile: boolean;
}

class App extends React.Component<any, IAppState> {

  componentWillMount () {
    this.setState({ loaded: false });
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  onLoad = () => {
    this.setState({ loaded: true });
  }

  handleResize = () => {
    this.setState({
        isMobile: (/Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
    })
  }

  public render() {

    const showOrientationTip = this.state.isMobile && window.matchMedia("(orientation: portrait)").matches;
    const noPortrait = require('./images/orientation.png');

    console.log('showOrientationTip', showOrientationTip)

      return (
        <div>
          <div className={`mobile dialog dialog-overlay ${showOrientationTip ? "" : "inactive"} portrait-lock`}>
              <p>Please rotate your phone to play</p>
              <img src={noPortrait} alt="use landscape" />
          </div>

          {
          this.state.loaded
          ? <BoardComponent />
          : <LoadingComponent onLoad={this.onLoad} />
          }

        </div>
      )

  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx